/* @flow */
import { ActionTypes } from 'constants/AvatarConstants';
import { dispatcher } from 'lib/Dispatcher';
import GroupAvatars from 'collections/GroupAvatars';

export function loadGroupAvatars(): Promise<GroupAvatars> {
  return GroupAvatars.fetch().then(avatars => {
    dispatcher.dispatch({
      type: ActionTypes.GROUP_AVATARS_LOADED,
      avatars,
    });
    return avatars;
  });
}

export function fetchGroupAvatar(groupName: string): Promise<GroupAvatars> {
  return GroupAvatars.fetch(groupName);
}

export default {
  loadGroupAvatars,
  fetchGroupAvatar,
};
